import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'betType'
})
export class BetTypePipe implements PipeTransform {

  transform(value: any): any {
    if (value == null) {
      return ''; // Varsayılan değer
    }
    return (value === 'bm') ? 'RACES.BOOKMAKER' : (value === 'fo') ? 'RACES.FIXED_ODDS_BET' : (value === 'rt') ? 'RACES.RACING_CLUB' : value;
  }

}
